import { LicenseInfo } from '@mui/x-license';

// Initialize MUI X license key after config is available
export const initializeMuiLicense = async () => {
  const licenseKey = import.meta.env.VITE_MUI_X_LICENSE_KEY;

  if (licenseKey) {
    LicenseInfo.setLicenseKey(licenseKey);
    console.log('MUI X Premium license applied');
  } else {
    console.warn(
      'MUI X license key not provided - premium features will show watermarks'
    );
  }
};
